import { render } from "./DireccionModal.vue?vue&type=template&id=26285827"
import script from "./DireccionModal.vue?vue&type=script&lang=js"
export * from "./DireccionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__